<div class="label-submenu">
    <adapt-menu *adaptLoading="!itemMenu"
                [items]="itemMenu"
                orientation="vertical"></adapt-menu>
</div>
